import { Arrow } from '@radix-ui/react-dropdown-menu'
import { breakpoints } from '~components/breakpoints'
import { styled } from '~styles/stitches.config'

export const DMArrow = styled(Arrow, { fill: '$panel', bp: breakpoints })
